// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 0.9em;
  display: block;
  opacity: 0.3;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
  right: 1em;
  content: "↑";
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  right: 0.5em;
  content: "↓";
}

table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:after {
  opacity: 1;
}

table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  opacity: 0;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:before,
div.dataTables_scrollBody table thead .sorting_asc:before,
div.dataTables_scrollBody table thead .sorting_desc:before,
div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner {
  box-sizing: content-box;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
  div.dataTables_wrapper div.dataTables_filter,
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-sm > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
  top: 5px;
  right: 0.85em;
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
  top: 5px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CourseRefunds/datatables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;EAME,mBAAA;AAEF;;AAAA;;EAEE,aAAA;AAGF;;AADA;;;;;EAKE,eAAA;EACA,kBAAA;AAIF;;AAFA;;;;;;;;;;EAUE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AAKF;;AAHA;;;;;EAKE,UAAA;EACA,YAAA;AAMF;;AAJA;;;;;EAKE,YAAA;EACA,YAAA;AAOF;;AALA;;EAEE,UAAA;AAQF;;AANA;;EAEE,UAAA;AASF;;AAPA;EACE,2BAAA;AAUF;;AARA;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;AAWF;;AATA;;;;;;EAME,aAAA;AAYF;;AAVA;;EAEE,gBAAA;AAaF;;AAXA;EACE,uBAAA;AAcF;;AAZA;EACE,wBAAA;EACA,gBAAA;AAeF;;AAbA;EACE;;;;IAIE,kBAAA;EAgBF;AACF;AAdA;EACE,mBAAA;AAgBF;;AAdA;;;EAGE,QAAA;EACA,aAAA;AAiBF;;AAfA;;;EAGE,QAAA;AAkBF;;AAhBA;;EAEE,oBAAA;AAmBF;;AAjBA;;;;EAIE,qBAAA;AAoBF;;AAlBA;;EAEE,sBAAA;AAqBF;;AAnBA;EACE,sBAAA;AAsBF;;AApBA;EACE,SAAA;AAuBF;;AArBA;EAIE,eAAA;AAqBF;;AAnBA;EAIE,gBAAA;AAmBF","sourcesContent":["table.dataTable thead > tr > th.sorting_asc,\r\ntable.dataTable thead > tr > th.sorting_desc,\r\ntable.dataTable thead > tr > th.sorting,\r\ntable.dataTable thead > tr > td.sorting_asc,\r\ntable.dataTable thead > tr > td.sorting_desc,\r\ntable.dataTable thead > tr > td.sorting {\r\n  padding-right: 30px;\r\n}\r\ntable.dataTable thead > tr > th:active,\r\ntable.dataTable thead > tr > td:active {\r\n  outline: none;\r\n}\r\ntable.dataTable thead .sorting,\r\ntable.dataTable thead .sorting_asc,\r\ntable.dataTable thead .sorting_desc,\r\ntable.dataTable thead .sorting_asc_disabled,\r\ntable.dataTable thead .sorting_desc_disabled {\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\ntable.dataTable thead .sorting:before,\r\ntable.dataTable thead .sorting:after,\r\ntable.dataTable thead .sorting_asc:before,\r\ntable.dataTable thead .sorting_asc:after,\r\ntable.dataTable thead .sorting_desc:before,\r\ntable.dataTable thead .sorting_desc:after,\r\ntable.dataTable thead .sorting_asc_disabled:before,\r\ntable.dataTable thead .sorting_asc_disabled:after,\r\ntable.dataTable thead .sorting_desc_disabled:before,\r\ntable.dataTable thead .sorting_desc_disabled:after {\r\n  position: absolute;\r\n  bottom: 0.9em;\r\n  display: block;\r\n  opacity: 0.3;\r\n}\r\ntable.dataTable thead .sorting:before,\r\ntable.dataTable thead .sorting_asc:before,\r\ntable.dataTable thead .sorting_desc:before,\r\ntable.dataTable thead .sorting_asc_disabled:before,\r\ntable.dataTable thead .sorting_desc_disabled:before {\r\n  right: 1em;\r\n  content: \"\\2191\";\r\n}\r\ntable.dataTable thead .sorting:after,\r\ntable.dataTable thead .sorting_asc:after,\r\ntable.dataTable thead .sorting_desc:after,\r\ntable.dataTable thead .sorting_asc_disabled:after,\r\ntable.dataTable thead .sorting_desc_disabled:after {\r\n  right: 0.5em;\r\n  content: \"\\2193\";\r\n}\r\ntable.dataTable thead .sorting_asc:before,\r\ntable.dataTable thead .sorting_desc:after {\r\n  opacity: 1;\r\n}\r\ntable.dataTable thead .sorting_asc_disabled:before,\r\ntable.dataTable thead .sorting_desc_disabled:after {\r\n  opacity: 0;\r\n}\r\ndiv.dataTables_scrollHead table.dataTable {\r\n  margin-bottom: 0 !important;\r\n}\r\ndiv.dataTables_scrollBody table {\r\n  border-top: none;\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\ndiv.dataTables_scrollBody table thead .sorting:before,\r\ndiv.dataTables_scrollBody table thead .sorting_asc:before,\r\ndiv.dataTables_scrollBody table thead .sorting_desc:before,\r\ndiv.dataTables_scrollBody table thead .sorting:after,\r\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\r\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\r\n  display: none;\r\n}\r\ndiv.dataTables_scrollBody table tbody tr:first-child th,\r\ndiv.dataTables_scrollBody table tbody tr:first-child td {\r\n  border-top: none;\r\n}\r\ndiv.dataTables_scrollFoot > .dataTables_scrollFootInner {\r\n  box-sizing: content-box;\r\n}\r\ndiv.dataTables_scrollFoot > .dataTables_scrollFootInner > table {\r\n  margin-top: 0 !important;\r\n  border-top: none;\r\n}\r\n@media screen and (max-width: 767px) {\r\n  div.dataTables_wrapper div.dataTables_length,\r\n  div.dataTables_wrapper div.dataTables_filter,\r\n  div.dataTables_wrapper div.dataTables_info,\r\n  div.dataTables_wrapper div.dataTables_paginate {\r\n    text-align: center;\r\n  }\r\n}\r\ntable.dataTable.table-sm > thead > tr > th {\r\n  padding-right: 20px;\r\n}\r\ntable.dataTable.table-sm .sorting:before,\r\ntable.dataTable.table-sm .sorting_asc:before,\r\ntable.dataTable.table-sm .sorting_desc:before {\r\n  top: 5px;\r\n  right: 0.85em;\r\n}\r\ntable.dataTable.table-sm .sorting:after,\r\ntable.dataTable.table-sm .sorting_asc:after,\r\ntable.dataTable.table-sm .sorting_desc:after {\r\n  top: 5px;\r\n}\r\ntable.table-bordered.dataTable th,\r\ntable.table-bordered.dataTable td {\r\n  border-left-width: 0;\r\n}\r\ntable.table-bordered.dataTable th:last-child,\r\ntable.table-bordered.dataTable th:last-child,\r\ntable.table-bordered.dataTable td:last-child,\r\ntable.table-bordered.dataTable td:last-child {\r\n  border-right-width: 0;\r\n}\r\ntable.table-bordered.dataTable tbody th,\r\ntable.table-bordered.dataTable tbody td {\r\n  border-bottom-width: 0;\r\n}\r\ndiv.dataTables_scrollHead table.table-bordered {\r\n  border-bottom-width: 0;\r\n}\r\ndiv.table-responsive > div.dataTables_wrapper > div.row {\r\n  margin: 0;\r\n}\r\ndiv.table-responsive\r\n  > div.dataTables_wrapper\r\n  > div.row\r\n  > div[class^=\"col-\"]:first-child {\r\n  padding-left: 0;\r\n}\r\ndiv.table-responsive\r\n  > div.dataTables_wrapper\r\n  > div.row\r\n  > div[class^=\"col-\"]:last-child {\r\n  padding-right: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
